import { Edit } from '@mui/icons-material';
import {
    Box,
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from '@mui/material';
import ChevronLeft from 'icons/ChevronLeft';
import FormEditPrice from 'page-sections/group-registration-detail/FormEditPrice';
import ListHeader from 'page-sections/group-registration-detail/ListHeader';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from 'utils/axios';
import formatCurrency from 'utils/formatCurrency';

const GroupRegistrationDetailPage = () => {
    const { id } = useParams();
    const [tableData, setTableData] = useState();
    const [dataToEdit, setDataToEdit] = useState({
        id,
        invoice_amount: 0,
    });
    const [openModal, setOpenModal] = useState(false);
    const navigate = useNavigate();
    const getData = async () => {
        await axiosInstance
            .get(`/api/register-group-details/${id}`)
            .then(({ data }) => {
                setDataToEdit((prev) => ({
                    ...prev,
                    invoice_amount: data.invoice_amount,
                }));
                setTableData(data);
            })
            .catch((err) => console.log(err));
    };
    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const handleSuccessSubmit = () => {
        setOpenModal(false);
        getData();
    };

    return (
        <Box pt={2} pb={4}>
            <Button
                disableRipple
                startIcon={<ChevronLeft />}
                onClick={() => navigate(-1)}
            >
                {' '}
                Back{' '}
            </Button>

            <FormEditPrice
                open={openModal}
                onClose={() => setOpenModal(false)}
                data={dataToEdit}
                onSuccessSubmit={handleSuccessSubmit}
            />

            <ListHeader />

            <TableContainer component={Paper} sx={{ p: 2 }}>
                <Table
                    size="small"
                    sx={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}
                    aria-label="caption table"
                >
                    <TableBody>
                        <TableRow key={1}>
                            <TableCell align="left" sx={{ fontWeight: 'bold' }}>
                                Key
                            </TableCell>
                            <TableCell align="left" sx={{ fontWeight: 'bold' }}>
                                Value
                            </TableCell>
                        </TableRow>

                        {tableData && (
                            <>
                                <TableRow key={'full_name'}>
                                    <TableCell align="left">
                                        Full Name
                                    </TableCell>
                                    <TableCell align="left">
                                        {tableData.fullName}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'nik'}>
                                    <TableCell align="left">NIK</TableCell>
                                    <TableCell align="left">
                                        {tableData.nik}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'email'}>
                                    <TableCell align="left">Email</TableCell>
                                    <TableCell align="left">
                                        {tableData.email}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'profession'}>
                                    <TableCell align="left">
                                        Profession
                                    </TableCell>
                                    <TableCell align="left">
                                        {tableData.profession?.name}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'institution'}>
                                    <TableCell align="left">
                                        Institution
                                    </TableCell>
                                    <TableCell align="left">
                                        {tableData.institution}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'city'}>
                                    <TableCell align="left">City</TableCell>
                                    <TableCell align="left">
                                        {tableData.city}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'country'}>
                                    <TableCell align="left">Country</TableCell>
                                    <TableCell align="left">
                                        {tableData.country?.name}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'phone'}>
                                    <TableCell align="left">
                                        Phone Number
                                    </TableCell>
                                    <TableCell align="left">
                                        {tableData.phoneNumber}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'package'}>
                                    <TableCell align="left">Package</TableCell>
                                    <TableCell align="left">
                                        {tableData.package?.name}
                                    </TableCell>
                                </TableRow>
                            </>
                        )}

                        <TableRow>
                            <TableCell align="left" sx={{ fontWeight: 'bold' }}>
                                Symposium price
                            </TableCell>
                            <TableCell align="left">
                                {formatCurrency(
                                    tableData?.package?.sympoPrice || 0,
                                )}
                            </TableCell>
                        </TableRow>

                        <TableRow
                            key={'workshops'}
                            style={{
                                display:
                                    tableData?.workshops?.length > 0
                                        ? ''
                                        : 'none',
                            }}
                        >
                            <TableCell
                                align="left"
                                sx={{ fontWeight: 'bold' }}
                                colSpan={4}
                            >
                                Workshops
                            </TableCell>
                        </TableRow>

                        {tableData?.workshops?.length > 0 &&
                            tableData.workshops.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell
                                        align="left"
                                        style={{ paddingLeft: '30px' }}
                                    >
                                        {i + 1}. {row.name}
                                    </TableCell>
                                    <TableCell align="left">
                                        {formatCurrency(parseInt(row.price))}
                                    </TableCell>
                                </TableRow>
                            ))}

                        {tableData && (
                            <>
                                <TableRow key={'gross'}>
                                    <TableCell
                                        align="right"
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        Total Amount
                                    </TableCell>
                                    <TableCell align="left">
                                        {formatCurrency(tableData.grossAmount)}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'discount1'}>
                                    <TableCell
                                        align="right"
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        Discount Package
                                    </TableCell>
                                    <TableCell align="left">
                                        {formatCurrency(tableData.discount)}
                                    </TableCell>
                                </TableRow>

                                <TableRow key={'invoice'}>
                                    <TableCell
                                        align="right"
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        Invoice Amount
                                    </TableCell>
                                    <TableCell align="left">
                                        {formatCurrency(
                                            tableData.invoiceAmount,
                                        )}
                                        <Edit
                                            onClick={() => setOpenModal(true)}
                                            sx={{
                                                cursor: 'pointer',
                                                display:
                                                    localStorage.getItem(
                                                        'role',
                                                    ) === 'admin'
                                                        ? 'block'
                                                        : 'none',
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            </>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default GroupRegistrationDetailPage;
